import { message } from "antd";
import { fetchTrainingDetail } from "PlatForms/OrgLMS/Services/MentorServices/AssignedTrainingService";
import { useState, useEffect } from "react";

const useAssignedTraining = () => {
  const mentorId = localStorage.getItem("personalId");
  const token = localStorage.getItem("token");
  const [loadingGroups, setLoadingGroups] = useState(false);
  const [groupData, setGroupData] = useState([]);

  useEffect(() => {
    fetchGroupsData();
  }, []);

  const fetchGroupsData = async () => {
    setLoadingGroups(true);
    try {
      const data = await fetchTrainingDetail(mentorId, token);
      setGroupData(data);
    } catch (error) {
      message.error(error.message);
    }
    setLoadingGroups(false);
  };

  return {
    loadingGroups,
    groupData,
  };
};

export default useAssignedTraining;
